import { ADD_CHAT_MESSAGE, CLEAR_CHAT_MESSAGES } from './actionTypes';
import ReducerRegistry from '../base/redux/ReducerRegistry';
const initialState = [];
const chatLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_CHAT_MESSAGE:
            return action.payload ? [...state, action.payload] : state;
        case CLEAR_CHAT_MESSAGES:
            return [];
        default:
            return state;
    }
};
export default chatLogReducer;
ReducerRegistry.register('features/chat-log', chatLogReducer);
